import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { translationConstants } from "../../../../../../../constants";
import { centerListingActions } from "../../../../../../../redux/actions";
import ActivityCard from "../../../../../../../shared/components/ViewCenterCard/ActivityCard";
import ActivityDetail from "../../../../../../../shared/components/ActivityDetail/ActivityDetail";
import {loadingIndicator, dataEndMessage} from "../../../../../../../shared/utilitiies"

const ActivitiesTab = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const defaultQueryExpression = "id != null ";

  //-------initial gridstate
  const initialGridState = {
    length: 7,
    search: null,
    pageNumber: 1,
    orderBy: "id desc",
    filterQuery: defaultQueryExpression,
  };

  const [gridState, setGridState] = useState(initialGridState);
  const [activitiesArary, setActivitiesArary] = useState([]);
  const [isViewDetail, setIsViewDetail] = useState(null);
  const [activityData, setActivityData] = useState(null);

  //-------reducers
  const centerListingReducer = useSelector(
    (state) => state.centerListingReducer
  );

  //-------destructure reducers
  const { centerActivities } = centerListingReducer;

  //-------Center Activities Listing
  const { pageData } = centerActivities;

  //-------Get More Centers Activities on Scroll
  const getMoreCenterActivities = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  //-------UseEffects
  useEffect(() => {
    dispatch(
      centerListingActions.getAllCenterActivities(gridState, props.centerId)
    );
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    setActivitiesArary(pageData);

    // eslint-disable-next-line
  }, [pageData]);

  return (
    <div className="row m-0">
      {isViewDetail ? (
        <ActivityDetail activityData={activityData} isBackButtonAllowed={false} />
      ) : (
        <InfiniteScroll
          dataLength={activitiesArary?.length ?? 0}
          next={getMoreCenterActivities}
          hasMore={
            activitiesArary?.length % 7 === 0 && activitiesArary?.length !== 0
              ? true
              : false
          }
          loader={loadingIndicator(t)}
          endMessage={dataEndMessage(t , activitiesArary)}
          style={{ overflow: "hidden" }}
          scrollableTarget={"main-container"}
        >
          <div className="row m-0 w-100 d-flex justify-content-center justify-content-md-center p-0">
            {activitiesArary?.map((activity) => {
              return (
                <ActivityCard
                  activity={activity}
                  setActivityData={setActivityData}
                  setIsViewDetail={setIsViewDetail}
                />
              );
            })}
          </div>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default ActivitiesTab;
